import React from "react";
import styles from "../styles/styles";

export default function EmergencyStatusGrid({
    title = "Emergência",
    items = []
}) {
    return (
        <div style={styles.emergencyGridContainer}>

            {/* LABEL LATERAL */}
            <div style={styles.emergencyGridLabel}>
                {title}
            </div>

            {/* GRID */}
            <div style={styles.emergencyGridWrapper}>
                {items.map((item, index) => (
                    <div
                        key={index}
                        style={{
                            ...styles.emergencyGridItem,

                            background: item.active
                                ? "#ef4444"
                                : "#ffffff",

                            color: item.active
                                ? "#ffffff"
                                : "#000000",

                            fontWeight: item.active
                                ? "bold"
                                : "normal"
                        }}
                    >
                        {item.label}
                    </div>
                ))}
            </div>

        </div>
    );
}